/* ==========================================================================
   PanelRoom > Client > Children > age
   ========================================================================== */

/* Modules */
const { html } = require('common-tags');

const ViewHelpers = require('@bluekiri/alexandria/core/ViewHelpers');
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');
const { addData, addStyle, randomId } = require('@bluekiri/alexandria/helpers/dataHelpers');

// eslint-disable-next-line max-len
const SelectTemplate = require('../../../../../select-panel/template');
const SelectClient = require('../../../../../select-panel/client/js');
const ActionsSelect = require('../../../../../select-panel/client/js/store/actions');

const { hasAges } = require('../utils');
const configuration = require('../../config');

function createPanel(instance, index) {
    const { config = {} } = instance;
    const { literals = {}, context = {} } = config;
    const { agesDescription = '' } = literals;

    const { markdown } = ViewHelpers(context);
    const renderAges = markdown(agesDescription);

    const template = html(/* html */ `
        <div class='${configuration().css.options}' ${`${configuration().hooks.ageSelectPanel}-${index}`}>
            <p class='${configuration().css.label}'>${renderAges}</p>
        </div>`);

    return toNode(template)[0];
}

function createAge(instance, data) {
    const { index, ageValue } = data;
    const { config = {} } = instance;
    const { context = {}, literals = {}, people = [] } = config;
    const { options = [] } = people[index];

    /* Prepare Select Options */
    let selectOptions = options;
    if (ageValue !== undefined) {
        selectOptions = options.map(option => {
            if (option.value === ageValue) return { ...option, selected: true };

            return { ...option, selected: false };
        });
    }

    const selectData = addStyle(
        addData(
            {
                config: {
                    literals: { ...literals, searchPlaceholderValue: '' },
                    panelStyle: 'select-panel__panel--age'
                },
                appendToParent: false,
                autoWidth: true,
                items: selectOptions
            },
            { type: randomId(randomId(configuration().type.age)) }
        ),
        [configuration().css.age]
    );

    const template = SelectTemplate(selectData, context);

    return toNode(template)[0];
}

function addAge(instance, data) {
    const { index, value: totalPeople } = data;
    const { people = [], hooks = {} } = instance;

    if (hasAges(instance, index) && totalPeople > 0) {
        /* create panel ages */
        if (!hooks[`options-${index}`]) {
            hooks[`options-${index}`] = createPanel(instance, index);
            people[index].counter.element.parentNode.appendChild(hooks[`options-${index}`]);
        }

        /* create age */
        const node = createAge(instance, data);
        hooks[[`options-${index}`]].appendChild(node);

        /* Init age */
        const { type } = node.dataset;

        initAge(instance, index, type);
    }
}

function initAge(instance, index, type) {
    const result = instance;
    const { selector, reactions = {}, people = [] } = instance;

    /* Init Select */
    const age = SelectClient(`${selector} [data-component="SelectPanel"][data-type="${type}"]`);

    /* Age reference: instance.people[index].ages */
    if (!people[index].ages) people[index].ages = [];
    people[index].ages = [...people[index].ages, age];

    if (!age) return;

    const ageIndex = people[index].ages.length - 1;
    const nameReaction = `age-change-${index}-${ageIndex}`;

    /* Extends reactions */
    result.reactions = {
        ...reactions,
        [`${nameReaction}`]: age.store.subscribe((state, action) => {
            if (action.type !== ActionsSelect.types.CHANGE_VALUE) return;

            /* data */
            const { value: selectValue } = state.data;

            /* Dispatch */
            instance.actions.setAge({
                peopleIndex: index,
                ageIndex,
                value: selectValue
            });

            instance.actions.change();
        })
    };
}

function destroyAge(instance, index) {
    const result = instance;
    const { people = [], hooks = {} } = instance;

    if (!people[index]) return;

    const { ages = [] } = people[index];

    const ageIndex = ages.length - 1;
    const reactionName = `age-change-${index}-${ageIndex}`;

    if (!ages[ageIndex]) return;
    /* Destroy */
    ages[ageIndex].actions.destroy();

    /* Unsbuscribe */
    instance.reactions[reactionName].unsubscribe();

    /* Remove references */
    ages.pop();
    delete result.reactions[reactionName];

    if (ageIndex === 0) {
        /* Remove node */
        hooks[`options-${index}`].remove();

        /* Remove reference */
        delete result.hooks[`options-${index}`];
    }
}

module.exports = {
    addAge,
    destroyAge
};
